import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  inject,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbDropdown,
  NgbModal,
  NgbDateStruct,
  NgbDatepicker,
  NgbDate,
  NgbCalendar,
} from '@ng-bootstrap/ng-bootstrap';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { NgxMasonryOptions } from 'ngx-masonry';
import { ToastrService } from 'ngx-toastr';
import { hasNativeLoginBridge, hasNativeScanBridge } from 'src/app/shared/auth/auth-runtime-context';
import { Subject, catchError, debounceTime, of, takeUntil, zip } from 'rxjs';
import { getRandomItems } from 'src/app/common/function';
import { KeyTitleModel } from 'src/app/models/key-value-model';
import { RestaurantDetails } from 'src/app/models/restaurant-details';
import { ArticleService } from 'src/app/services/article.service';
import { UserService } from 'src/app/services/user.service';
import {
  Article,
  ArticleFilter,
  ArticleLanguageType,
  DashboardArticle,
} from './../../models/article';
import { BusinessFilter } from './../../models/register-business';
import { BusinessService } from './../../services/business.service';
import { LoaderService } from './../../services/loader.service';

import { DeviceDetectorService } from 'ngx-device-detector';
import { DealsOfferComponent } from '../../shared/components/deals-offer/deals-offer.component';
import { DealsOfferFilter } from '../../models/deals-offers';
import { TranslationService } from '../../services/translation.service';
import { LocationSearchComponent } from 'src/app/shared/components/location-search/location-search.component';
import { MobileLocationDockComponent } from 'src/app/shared/components/mobile-location-dock/mobile-location-dock.component';

export enum ArticleFilterTabType {
  DetailsTab,
  DateFilterTab,
  CategoryTab,
  CreatedByTab,
  RatingByTab,
  PriceRangeTab,
  TypeOfMealTab,
}

export class chips {
  id: number;
  name: string;
  isArticle: boolean;
  type: ArticleFilterTabType;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('hidden => visible', animate('500ms ease-in')),
    ]),
  ],
})
export class DashboardComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('sliderRef') sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('filterDropdownMenu') filterDropdownMenu: ElementRef;
  @ViewChild('myDrop') myDrop: NgbDropdown;
  @ViewChild('viewArticleModal') viewArticleModel: TemplateRef<any>;

  @ViewChildren('newslistItem') newsListItems!: QueryList<ElementRef>;
  @ViewChildren('dealsListItems') dealsListItems!: QueryList<ElementRef>;
  @ViewChild('dp') datepicker: NgbDatepicker;
  @ViewChild('dashboardSearchBar') dashboardSearchBar: any;
  @ViewChild('dashboardDesktopLocationSearch') dashboardDesktopLocationSearch?: LocationSearchComponent;
  @ViewChild('dashboardMobileLocationDock') dashboardMobileLocationDock?: MobileLocationDockComponent;
  @ViewChild('dummyButton', { static: true })
  dummyButton!: ElementRef<HTMLButtonElement>;

  currentSlide: number = 0;
  dotHelper: Array<Number> = [];
  slider!: KeenSliderInstance;
  articleList: DashboardArticle[] = [];
  selectedArticlId: number;

  isSearchBarActive = false;
  articleFilterTabType = ArticleFilterTabType;

  throttle = 500;
  scrollDistance = 1;
  scrollUpDistance = 5;
  articleFilter: ArticleFilter = new ArticleFilter();
  articles: DashboardArticle[] = [];
  pagesize = 20;
  totalPage = 0;
  currentPage = 1;
  totalRecord = 0;
  selectedArticle: Article;
  fromdropdownVisible = false;
  todropdownVisible = false;
  types: { id: number; name: string }[];
  peoples: { id: number; name: string }[];
  typeSelect: boolean[] = [];
  peopleSelect: boolean[] = [];
  businessList: RestaurantDetails[] = [];
  foodieNews: any[] = [];
  foodieDealsOffers: any[] = [];
  loading = false;
  delay: number = 1200; // Give users time to choose Article vs Restaurant before searching.
  afterSearchDelay: number = 0;
  searchOnGoing: boolean = false;
  firstTimeListLoad: boolean = true;
  businessFilter: BusinessFilter = { limit: 100 } as BusinessFilter;
  isQRScanBtnClick = false;
  isFilterBtnClick = false;
  isSearchBtnClick = false;
  isfetchingData = false;
  fromDateControl: FormControl = new FormControl();
  toDateControl: FormControl = new FormControl();
  priceRanges: KeyTitleModel[] = [];
  selectedPrices: boolean[] = [];
  typeOfMeals: KeyTitleModel[] = [];
  selectedTypeOfMeals: boolean[] = [];
  categories: KeyTitleModel[] = [];
  selectedCategories: boolean[] = [];
  searchText: string = '';
  searchChanged = new Subject();
  filterChanged = new Subject();
  listingFilterChanged = new Subject();
  filter: BusinessFilter = new BusinessFilter();
  articleFilterOption = { showfilterDetails: true } as {
    showfilterDetails: boolean;
    showDateFilter: boolean;
    showCategoryFilter: boolean;
    showCreatedByFilter: boolean;
  };
  uploadedBy: number;
  selectedDate: NgbDateStruct;
  displaySelectedType: string[] = [];
  displayselectedPeople: string[] = [];
  displayFilterChips: chips[] = [];
  isLayoutComplete: boolean = false;
  isFirstTime: boolean = true;
  isRedirectedForArticleApproval: boolean = false;
  isMobileView: boolean;
  private destroy$ = new Subject<void>();
  get isclearButtonShow() {
    return (
      !this.searchText || (window.innerWidth < 767 && !this.isSearchBarActive)
    );
  }
  loaderItems = new Array(3);

  get isMobile() {
    return window.innerWidth < 767;
  }

  get shouldUseMobileFilterBar() {
    return this.isMobile || this.isFromMobileApp;
  }

  get shouldShowQRButton() {
    return hasNativeScanBridge(window as any);
  }
  get mobileLocationLabel() {
    return this.selectedLocation?.address || 'Location';
  }
  get hasMobileLocationSelection() {
    return !!this.selectedLocation?.address;
  }
  city: string;
  selectedLocation: { lat: number; lng: number; address: string } | null = null;
  isDashboardLocationSearchOpen = false;
  mobileLocationOriginRect: { left: number; width: number } | null = null;
  isDashboardLocationOpening = false;
  isDashboardLocationClosing = false;
  clearLocation = false;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null;
  isFromMobileApp: boolean = false;
  isMouseOverBlock: boolean = false;
  dealsOfferFilter: DealsOfferFilter = { limit: 100, callFromHungery: true } as DealsOfferFilter;
  isRestaurantSelected: boolean = false;
  debounceTimer: any;
  private dashboardLocationMotionTimeout: any;
  private lastMobileLocationTouchAt = 0;
  language: ArticleLanguageType = ArticleLanguageType.English;
  prevLanguage: ArticleLanguageType = ArticleLanguageType.English;
  @ViewChild('scrollBarContainer') scrollBarContainerRef!: ElementRef;
  scrollTimeout: any;
  private bannerChunkTimeouts: any[] = [];

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private articleService: ArticleService,
    private userService: UserService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private re: Router,
    private businessService: BusinessService,
    private calendar: NgbCalendar,
    private deviceDetector: DeviceDetectorService,
    public translationService: TranslationService,
    private cdr: ChangeDetectorRef,
  ) // public translationService: TranslationService
  {
    this.isMobileView = deviceDetector.isMobile();
    this.prevLanguage = this.language;
    this.language = this.translationService.language == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
  }

  viewSearchBar(e) {
    e.preventDefault();
    this.dashboardSearchBar.nativeElement.focus();
    const searchText = (this.searchText || '').trim();

    if (window.innerWidth < 767) {
      if (this.isSearchBarActive && searchText) {
        if (this.isRestaurantSelected) {
          this.filter.search = searchText;
          this.applyListingFilter(true);
        } else {
          this.articleList = [];
          this.applyFilter();
        }
      }
      this.isSearchBarActive = !this.isSearchBarActive;
      if (!this.isSearchBarActive) {
        this.dashboardSearchBar.nativeElement.blur();
      }
    } else if (searchText) {
      if (this.isRestaurantSelected) {
        this.filter.search = searchText;
        this.applyListingFilter(true);
      } else {
        this.articleList = [];
        this.applyFilter();
      }
    }
  }

  // From the floating location field: bail out into the text search bar mid-type.
  switchDashboardToSearch() {
    this.collapseDashboardLocationSearch();
    this.myDrop?.close();
    this.isSearchBarActive = true;
    this.cdr.detectChanges();
    setTimeout(() => this.dashboardSearchBar?.nativeElement?.focus(), 0);
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: any) {
    let searchBtn = document.querySelector('.btn-search');
    let filterBtn = document.querySelector('.btn-filter');
    let scanBtn = document.querySelector('.btn-scan');
    let searchbar = document.querySelector('.search-wrap');
    let filterDropDown = document.querySelector('.filter-dropdown');
    //if (
    //  event &&
    //  !filterDropDown.contains(event.target) &&
    //  !event.target.closest('.btn-chips')
    //) {
    //  this.active = 'articles';
    //}

    if (
      !searchBtn.contains(event.target) &&
      !searchbar.contains(event.target) &&
      !this.searchText
    ) {
      this.isSearchBarActive = false;
      this.isSearchBtnClick = false;
    }
    if (!filterBtn.contains(event.target)) {
      this.isFilterBtnClick = false;
    }
    if (scanBtn && !scanBtn.contains(event.target)) {
      this.isQRScanBtnClick = false;
    }
    const mobileLocationEditor = document.querySelector('.mobile-location-dock');
    if (
      this.isDashboardLocationSearchOpen &&
      this.shouldUseMobileFilterBar &&
      (!mobileLocationEditor || !mobileLocationEditor.contains(event.target))
    ) {
      this.collapseDashboardLocationSearch();
      this.myDrop?.close();
    }
  }

  // changeLanguage(language: string): void {
  //   this.translationService.changeLanguage(language);
  // }

  // trackBy for the dashboard's four data lists: without it every refresh rebuilt
  // the full DOM (and ngx-masonry re-measured every card). Falls back to the index
  // for records that carry no id.
  trackByEntityId(index: number, item: any): number {
    return item?.id ?? index;
  }

  hideSearchBar() {
    if (this.myDrop.isOpen()) {
      this.myDrop.close();
    }

    if (!this.searchText) {
      this.isSearchBarActive = false;
    }
  }

  toggleDropdown(visible: boolean, datePicker: string) {
    if (datePicker == 'from') {
      this.fromdropdownVisible = visible;
    }
    if (datePicker == 'to') {
      this.todropdownVisible = visible;
    }
  }

  clearFilter() {
    //this.formGroup.reset();
    this.typeSelect = [];
    this.peopleSelect = [];
    this.articleList = [];
    this.articleFilter = new ArticleFilter();
    this.currentPage = 1;
    this.loadData();
  }

  get isFiterApply() {
    return (this.fromDateControl.value && this.toDateControl.value) ||
      this.typeSelect?.length ||
      this.uploadedBy != null
      ? true
      : false;
  }

  applyFilter() {
    this.articleFilter.searchText = this.searchText;

    if (
      this.fromDateControl.value != '' &&
      this.fromDateControl.value != null
    ) {
      this.articleFilter.fromDate = this.formateDate(
        this.fromDateControl.value
      );
    } else {
      this.articleFilter.fromDate = null;
    }
    if (this.toDateControl.value != '' && this.toDateControl.value != null) {
      this.articleFilter.toDate = this.formateDate(this.toDateControl.value);
    } else {
      this.articleFilter.toDate = null;
    }

    this.articleList = [];
    this.currentPage = 1;
    this.loading = true;
    this.loadData();
  }

  applyListingFilter(isRedirect = true, force = false) {
    this.filter.search = this.filter.search || '';
    this.filter.FilterByPriceRange = '';
    this.filter.FilterByCategories = '';
    this.filter.FilterByMealType = '';
    var tempSelectedPrice = '';
    var tempSelectedTypeOfMeals = '';
    var tempSelectedCategories = '';
    this.selectedPrices.forEach((x, i) => {
      if (x) {
        tempSelectedPrice = tempSelectedPrice.concat(
          this.priceRanges[i].id.toString() + ', '
        );
      }
    });

    this.selectedTypeOfMeals.forEach((x, i) => {
      if (x) {
        tempSelectedTypeOfMeals = tempSelectedTypeOfMeals.concat(
          this.typeOfMeals[i].id.toString() + ', '
        );
      }
    });
    this.selectedCategories.forEach((x, i) => {
      if (x) {
        tempSelectedCategories = tempSelectedCategories.concat(
          this.categories[i].id.toString() + ', '
        );
      }
    });

    if (!force &&
      tempSelectedPrice == this.filter.FilterByPriceRange &&
      tempSelectedTypeOfMeals == this.filter.FilterByMealType &&
      tempSelectedCategories == this.filter.FilterByCategories &&
      this.filter.search.length < 3 &&
      !this.selectedLocation
    ) {
      return;
    } else {
      this.filter.FilterByPriceRange = tempSelectedPrice;
      this.filter.FilterByCategories = tempSelectedCategories;
      this.filter.FilterByMealType = tempSelectedTypeOfMeals;
    }
    const isLocationIntent = !!this.selectedLocation || force;
    const filterForListing = Object.assign({}, this.filter);
    if (!isLocationIntent) {
      filterForListing.origin_Lat = null;
      filterForListing.origin_long = null;
      filterForListing.north = null;
      filterForListing.south = null;
      filterForListing.east = null;
      filterForListing.west = null;
      filterForListing.zoomLevel = null;
      filterForListing.enableZoomFallBack = false;
    }

    this.businessService.clearListingReturnPending();
    this.businessService.clearListingState();
    this.businessService.filterDataObject = {
      source: isLocationIntent ? 'dashboard-location' : 'dashboard-search',
      filter: filterForListing,
      selectedPrices: this.selectedPrices,
      selectedTypeOfMeals: this.selectedTypeOfMeals,
      selectedCategories: this.selectedCategories,
      displayFilterChips: this.displayFilterChips.filter((x) => !x.isArticle),
      city: isLocationIntent ? this.city : null,
      selectedLocation: isLocationIntent ? this.selectedLocation : null,
    };
    if (isRedirect) {
      this.re.navigate(['/listing']);
    }
  }

  toggleDashboardLocationSearch(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.active = 'place';
    if (this.isDashboardLocationSearchOpen) {
      this.focusDashboardLocationSearch(true);
      return;
    }
    this.setDashboardLocationMotion('opening');
    this.isDashboardLocationSearchOpen = true;
    this.focusDashboardLocationSearch(true);
  }

  openDashboardLocationSearch(event?: Event) {
    if (event?.type === 'touchstart') {
      this.lastMobileLocationTouchAt = Date.now();
    } else if (event?.type === 'click' && Date.now() - this.lastMobileLocationTouchAt < 600) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event?.preventDefault();
    event?.stopPropagation();
    // Measure the pill before it is hidden, so the field can expand out of its footprint.
    const trigger = event?.currentTarget as HTMLElement | null;
    const triggerRect = trigger?.getBoundingClientRect?.();
    this.mobileLocationOriginRect = triggerRect?.width
      ? { left: triggerRect.left, width: triggerRect.width }
      : null;
    if (!this.isDashboardLocationSearchOpen) {
      this.toggleDashboardLocationSearch(event);
      return;
    }
    this.focusDashboardLocationSearch(true);
  }

  clearDashboardLocation(event?: Event) {
    if (event?.type === 'touchstart') {
      this.lastMobileLocationTouchAt = Date.now();
    } else if (event?.type === 'click' && Date.now() - this.lastMobileLocationTouchAt < 600) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event?.preventDefault();
    event?.stopPropagation();
    this.collapseDashboardLocationSearch();
    this.resetDashboardLocationToDeviceEpicenter(true);
  }

  // The active-filter row's x. Unlike the in-panel clear it stays put: removing a filter from
  // the row should not navigate the user somewhere else.
  removeDashboardLocationFilter(event?: Event) {
    if (event?.type === 'touchstart') {
      this.lastMobileLocationTouchAt = Date.now();
    } else if (event?.type === 'click' && Date.now() - this.lastMobileLocationTouchAt < 600) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event?.preventDefault();
    event?.stopPropagation();
    this.collapseDashboardLocationSearch();
    this.resetDashboardLocationToDeviceEpicenter(false);
  }

  onDashboardLocationSelected(location: { lat: number; lng: number; address: string } | null) {
    if (!location?.address) {
      const hadLocation = !!this.city || !!this.selectedLocation || !!this.filter.origin_Lat || !!this.filter.origin_long;
      this.city = '';
      this.selectedLocation = null;
      this.filter.origin_Lat = '';
      this.filter.origin_long = '';
      this.clearLocation = false;
      if (!hadLocation) {
        return;
      }
      // Emptying the field only drops the location filter. It must not close the editor or
      // navigate — while the field is open, only a real interaction ends the session.
      if (!this.isDashboardLocationSearchOpen && this.active === 'place' && !this.shouldUseMobileFilterBar) {
        this.resetDashboardLocationToDeviceEpicenter(true);
      }
      return;
    }

    clearTimeout(this.debounceTimer);
    const searchText = (this.searchText || '').trim();
    this.filter.search = searchText.length > 2 ? searchText : '';
    this.city = location.address;
    this.selectedLocation = location;
    this.filter.origin_Lat = location.lat.toString();
    this.filter.origin_long = location.lng.toString();
    this.filter.zoomLevel = 20;
    this.filter.enableZoomFallBack = true;
    // Picking a suggestion completes the edit, so close the field on that interaction.
    this.collapseDashboardLocationSearch();
    this.applyListingFilter(true);
  }

  onDashboardFilterDropdownOpenChange(isOpen: boolean) {
    // Not while the location editor is up. The editor lives outside this dropdown, so ngb's
    // "click outside" autoclose fires for taps on the field and on its suggestions — collapsing
    // here would close the editor under the user's finger and swallow the suggestion tap. The
    // panel is hidden during editing anyway; dismissal is handled by handleOutsideClick.
    if (!isOpen && !this.isDashboardLocationSearchOpen) {
      this.collapseDashboardLocationSearch();
    }
  }

  collapseDashboardLocationSearch() {
    if (this.isDashboardLocationSearchOpen) {
      this.setDashboardLocationMotion('closing');
    }
    this.isDashboardLocationSearchOpen = false;
  }

  private setDashboardLocationMotion(state: 'opening' | 'closing' | null) {
    if (this.dashboardLocationMotionTimeout) {
      clearTimeout(this.dashboardLocationMotionTimeout);
      this.dashboardLocationMotionTimeout = null;
    }

    const shouldAnimate = !this.shouldUseMobileFilterBar && !this.isFromMobileApp;
    this.isDashboardLocationOpening = shouldAnimate && state === 'opening';
    this.isDashboardLocationClosing = shouldAnimate && state === 'closing';

    if (state && shouldAnimate) {
      const duration = state === 'opening' ? 260 : 560;
      this.dashboardLocationMotionTimeout = setTimeout(() => {
        this.isDashboardLocationOpening = false;
        this.isDashboardLocationClosing = false;
        this.dashboardLocationMotionTimeout = null;
        this.cdr.markForCheck();
      }, duration);
    }
  }

  private focusDashboardLocationSearch(selectAll = false) {
    this.cdr.detectChanges();
    const focusTarget = this.shouldUseMobileFilterBar
      ? this.dashboardMobileLocationDock
      : this.dashboardDesktopLocationSearch;
    focusTarget?.focusInput(selectAll);
    setTimeout(() => focusTarget?.focusInput(selectAll), 0);
    setTimeout(() => focusTarget?.focusInput(selectAll), 150);
  }

  private resetDashboardLocationToDeviceEpicenter(redirect: boolean) {
    this.city = '';
    this.selectedLocation = null;
    this.filter.origin_Lat = '';
    this.filter.origin_long = '';
    this.filter.zoomLevel = 20;
    this.filter.enableZoomFallBack = true;

    this.userService.getCurrentLatLng().then((position) => {
      this.filter.origin_Lat = position.lat?.toString();
      this.filter.origin_long = position.lng?.toString();
      this.applyListingFilter(redirect, true);
    }, () => {
      this.applyListingFilter(redirect, true);
    });
  }

  showOpenResturant() {
    this.applyListingFilter(false);
    this.businessService.setCloseOpenValue({
      showOpen: true,
      showClose: false,
    });
    this.re.navigate(['/listing']);
  }

  showCloseResturant() {
    this.applyListingFilter(false);
    this.businessService.setCloseOpenValue({
      showOpen: false,
      showClose: true,
    });
    this.re.navigate(['/listing']);
  }

  formateDate(dateRange: any) {
    if (!dateRange) {
      return null;
    }
    const dateString = JSON.stringify(dateRange);
    const dateValue = JSON.parse(dateString);
    const dateObj =
      `{year: ${dateValue.year}, month: ${dateValue.month}, day: ${dateValue.day}}` as string;
    const parts = dateObj.split(/[\s{},:]+/);
    const selectedDate = new Date(
      parseInt(parts[2]),
      parseInt(parts[4]) - 1,
      parseInt(parts[6])
    );
    const date = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        0,
        0,
        0
      )
    );
    return date;
  }

  QRScanClick() {
    localStorage.setItem('isQRScanClick', 'true');
    setTimeout(() => {
      this.isQRScanBtnClick = false;
    }, 300);
  }

  public masonryOptions: NgxMasonryOptions = {
    resize: true,
    horizontalOrder: true,
    initLayout: true,
    animations: {
      show: [
        style({ opacity: 0 }),
        animate('400ms ease-in', style({ opacity: 1 })),
      ],
      hide: [
        style({ opacity: '*' }),
        animate('400ms ease-in', style({ opacity: 0 })),
      ],
    },
  };

  public masonryOptionsForLoader: NgxMasonryOptions = {
    resize: true,
    horizontalOrder: true,
    initLayout: true,
    animations: {
      show: [
        style({ opacity: 0 }),
        animate('400ms ease-in', style({ opacity: 1 })),
      ],
      hide: [
        style({ opacity: '*' }),
        animate('400ms ease-in', style({ opacity: 0 })),
      ],
    },
  };

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    setTimeout(() => {
      if (this.slider) {
        this.slider.update();
        if (this.slider.track.details?.slides.length > 0) {
          this.dotHelper = [
            ...Array(this.slider.track.details.slides.length).keys(),
          ];
        }
      }
    }, 0);
    this.isMobileView = this.deviceDetector.isMobile();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider = new KeenSlider(
        this.sliderRef.nativeElement,
        {
          initial: this.currentSlide,
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel;
          },
          // loop: true,
        },
        [
          (slider) => {
            let timeout: any;
            let mouseOver = false;
            function clearNextTimeout() {
              clearTimeout(timeout);
            }
            function nextTimeout() {
              clearTimeout(timeout);
              if (mouseOver) return;
              timeout = setTimeout(() => {
                // slider.next();
              }, 6000);
            }
            slider.on('created', () => {
              slider.container.addEventListener('mouseover', () => {
                mouseOver = true;
                clearNextTimeout();
              });
              slider.container.addEventListener('mouseout', () => {
                mouseOver = false;
                nextTimeout();
              });
              nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
          },
        ]
      );
    }, 0);

    //this.userService
    //  .getCurrentLocation()
    //  .then((result) => {
    //    this.city = result.city;
    //  })
    //  .catch((error) => {
    //    console.error(error);
    //  });

    this.userService
      .getCityByIP()
      .then((result) => {
        this.city = result;
      })
      .catch((error) => {
        console.error(error);
      });

    const targetBlock = document.querySelector('.filter-dropdown');

    this.renderer.listen(targetBlock, 'mouseenter', () => {
      this.isMouseOverBlock = true;
    });

    this.renderer.listen(targetBlock, 'mouseleave', () => {
      this.isMouseOverBlock = false;
    });

    this.renderer.listen('window', 'scroll', () => {
      if (this.myDrop.isOpen() && !this.isMouseOverBlock) {
        this.myDrop.close();
      }
    });

    this.renderer.listen(this.dashboardSearchBar.nativeElement, 'blur', (e) => {
      let searchBtn = document.querySelector('.btn-search');
      if (e && !searchBtn.contains(e.target)) {
        return;
      }

      if (!this.searchText) {
        this.isSearchBarActive = false;
      }
    });
    // Section pinning (keeping the hero/content under the header so users don't overscroll
    // to the footer) is now pure CSS `position: sticky` — see dashboard.component.scss.
    // It used to be a gsap ScrollTrigger pin whose always-on requestAnimationFrame ticker
    // ran change detection every frame and saturated the main thread.
  }

  private setDashboardBanners(records: any[]) {
    const shouldProgressivelyLoadBanners = this.isMobileView || window.innerWidth < 1200;
    const imageTypeRsp = shouldProgressivelyLoadBanners ? 3 : 1;
    const banners = records
      .map((business) => {
        const primaryImage = business?.membershipBusinessImagesList?.find(
          (x) => x.imageType == 1
        );

        if (!primaryImage?.imagePath) {
          return null;
        }

        return {
          index: 0,
          id: business.branchId,
          photo: primaryImage.imagePath,
          restaurantName: business.name,
          typeName: business.typeName,
          cuisineName: business.cuisineName,
          memberShipImageConfigurationList: primaryImage?.memberShipImageConfigurationViews?.find(
            (y) => y.imageType == imageTypeRsp
          )
        } as RestaurantDetails;
      })
      .filter(Boolean) as RestaurantDetails[];

    const selectedBanners = getRandomItems(banners, shouldProgressivelyLoadBanners ? 12 : 10)
      .map((banner, index) => ({ ...banner, index: index + 1 }));

    if (!shouldProgressivelyLoadBanners) {
      this.businessList = selectedBanners;
      return;
    }

    this.bannerChunkTimeouts.forEach((timeout) => clearTimeout(timeout));
    this.bannerChunkTimeouts = [];
    this.businessList = selectedBanners.slice(0, 3);

    for (let start = 3; start < selectedBanners.length; start += 3) {
      const timeout = setTimeout(() => {
        this.businessList = [
          ...this.businessList,
          ...selectedBanners.slice(start, start + 3)
        ];
        this.onResize();
        this.cdr.markForCheck();
      }, start * 250);
      this.bannerChunkTimeouts.push(timeout);
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
    this.bannerChunkTimeouts.forEach((timeout) => clearTimeout(timeout));
    if (this.dashboardLocationMotionTimeout) {
      clearTimeout(this.dashboardLocationMotionTimeout);
    }
    this.renderer.removeClass(document.body, 'landing-page-body');
    this.destroy$.next();
    this.destroy$.complete();
  }

  active = 'articles';
  activeInner = '1';

  // Code for adding class only for landing page.
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['articleId']) {
        this.openArticle(params['articleId']);
      } else {
        this.firstSection = document.getElementById('first-section');
        this.secondSection = document.getElementById('second-section');
        this.isFromMobileApp = hasNativeLoginBridge(window as any);
        this.renderer.addClass(document.body, 'landing-page-body');
        //this.loaderService.setLoading(true);
        this.loaderService.isDashboardLoading.next(true);
        this.loading = true;
        this.loadData();
        zip(
          this.articleService.getTopics(),
          this.articleService.getAuthors(),
          this.businessService.getBusinessList(this.businessFilter).pipe(
            catchError(() => of({ records: [] }))
          ),
          this.userService.getAll(`api/tenants/getMemberShipFoodieNewsDetails`),
          this.businessService.getDealsandOffers(this.dealsOfferFilter),
          this.businessService.getAll(
            `api/tenants/membershipApp/GetAllMembershipAppCompanyPriceRange`
          ),
          this.businessService.getAll(
            `api/tenants/membershipApp/getAllMembershipAppMealTypeList`
          ),
          this.userService.getAll(
            `/api/tenants/membershipApp/GetMembershipAppCompanyTypes`
          )
        ).subscribe(
          (response: any) => {
            if (
              response[0] &&
              response[1] &&
              response[2] &&
              response[3] &&
              response[4] &&
              response[5] &&
              response[6] &&
              response[7]
            ) {
              this.types = response[0].map((item) => ({
                id: item.id,
                name: item.name,
              }));
              this.peoples = response[1].map((items) => ({
                id: items.id,
                name: items.title,
              }));
              this.setDashboardBanners(response[2]?.records || []);
              this.loaderService.isDashboardLoading.next(false);
              this.foodieNews = response[3];
              this.foodieNews.forEach((x) => {
                x['isVisible'] = false;
              });
              this.foodieDealsOffers = response[4].records;
              this.foodieDealsOffers.forEach((x) => {
                x['isVisible'] = false;
                x['offerType'] = x.type == 1 ? 'Deal' : 'Offer'
              });
              setTimeout(() => {
                const newsObserver = new IntersectionObserver(
                  (entries) => {
                    entries.forEach((entry) => {
                      if (entry.isIntersecting) {
                        // Find the corresponding item and set it as visible
                        const index = +entry.target?.id;
                        if (index >= 0) {
                          this.foodieNews[index].isVisible = true;
                        }
                      }
                    });
                  },
                  { threshold: 0.1 } // Adjust as needed
                );

                const dealsObserver = new IntersectionObserver(
                  (entries) => {
                    entries.forEach((entry) => {
                      if (entry.isIntersecting) {
                        // Find the corresponding item and set it as visible
                        const index = +entry.target?.id;
                        if (index >= 0) {
                          this.foodieDealsOffers[index].isVisible = true;
                        }
                      }
                    });
                  },
                  { threshold: 0.1 } // Adjust as needed
                );

                // Observe each list item
                this.newsListItems.forEach((item) => {
                  newsObserver.observe(item.nativeElement);
                });

                this.dealsListItems.forEach((item) => {
                  dealsObserver.observe(item.nativeElement);
                });
              }, 1000);
              this.priceRanges = this.sortItems(
                response[5].map((item) => ({
                  id: item.id,
                  title: item.title,
                }))
              );
              this.typeOfMeals = this.sortItems(
                response[6].map((item) => ({
                  id: item.id,
                  title: item.title,
                }))
              );
              this.categories = this.sortItems(
                response[7].map((item) => ({
                  id: item.id,
                  title: item.title,
                }))
              );

              this.onResize();
              this.loaderService.setLoading(false);
            }
          },
          (err) => {
            this.loaderService.setLoading(false);
          }
        );

        this.searchChanged.pipe(
          debounceTime(this.delay),
          takeUntil(this.destroy$)
        ).subscribe(() => {
          if (this.isRestaurantSelected) {
            return;
          }
          if (
            (this.searchText.trim() === '' &&
              this.articleFilter?.searchText?.trim() !== '') ||
            (this.searchText?.trim() !== '' &&
              this.articleFilter?.searchText?.trim() !==
              this.searchText?.trim())
          ) {
            if (this.searchOnGoing) {
              setTimeout(() => {
                this.articleList = [];
                this.applyFilter();
              }, 1000);
            } else {
              this.searchOnGoing = true;
              this.articleList = [];
              this.applyFilter();
            }
          }
        });

        this.filterChanged.pipe(debounceTime(1800)).subscribe((res) => {
          this.articleList = [];
          this.applyFilter();
        });

        this.listingFilterChanged.pipe(debounceTime(1800)).subscribe((res) => {
          this.applyListingFilter();
        });

        // Subscribe to language change events
        this.translationService.changeLangEmitted$
          .pipe(takeUntil(this.destroy$))
          .subscribe(lang => {
            this.prevLanguage = this.language;
            this.language = lang == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
            this.currentPage = 1;
            this.articleList = [];
            this.loadData();
          });
      }
    });
  }

  loadImages(e) {
    setTimeout(() => {
      this.isFirstTime = false;
    }, 400);
  }

  onSearch($event) {
    const searchText = (this.searchText || '').trim();
    const isListingSearch = this.isRestaurantSelected || this.active === 'place';
    if (isListingSearch) {
      clearTimeout(this.debounceTimer);
      if (searchText.length <= 2) {
        this.filter.search = '';
        return;
      }
      this.filter.search = searchText;
      this.debounceTimer = setTimeout(() => {
        this.applyListingFilter();
      }, 2000);
      return;
    }

    this.searchChanged.next($event);
  }

  onRestaurantClick() {
    // Restaurant toggle is a plain name-search mode: keep the articles bar layout
    // (no location chip / place configuration) and wait for typed input.
    this.isRestaurantSelected = !this.isRestaurantSelected;
    this.activeInner = '1';
    clearTimeout(this.debounceTimer);
    const searchText = (this.searchText || '').trim();
    if (searchText.length > 2 && this.isRestaurantSelected) {
      this.filter.search = searchText;
      this.applyListingFilter();
    }
  }

  onFilterChange($event) {
    this.articleFilter.category = this.types
      .filter((x, i) => this.typeSelect[i])
      .map((x) => x.id);

    this.displaySelectedType = this.types
      ?.filter((x) => this.articleFilter?.category?.some((y) => y == x.id))
      .map((x) => x.name);

    this.articleFilter.uploadedByUserId = [this.uploadedBy];

    this.displayselectedPeople = this.peoples
      ?.filter((x) =>
        this.articleFilter?.uploadedByUserId?.some((y) => y == x.id)
      )
      .map((x) => x.name);
    this.filterChanged.next($event);
  }

  totalImages: number;
  totalLoadedImages: number = 0;

  loadData() {
    this.articles = [];
    this.isfetchingData = true;
    this.articleFilter.showOnlyMyArticle = false;
    this.articleFilter.pageSize = this.pagesize;
    this.articleFilter.pageNumber = this.currentPage;
    this.articleFilter.language = this.language;
    this.articleService.getArticleForDashboard(this.articleFilter).subscribe(
      (res: any) => {
        this.totalRecord = res.total;
        this.totalPage = res.total / this.pagesize;
        if (res && res.records) {
          this.articles = res.records.map((item) => {
            let article = new Article();
            article.id = item.id;
            article.carouselData = JSON.parse(item.carouselData);
            article.title = item.title?.replace(/<[^>]*>/g, '');
            article.description = item.description?.replace(/<[^>]*>/g, '').substring(0, 150);
            article.mainImage = item.mainImage;

            return article;
          });
          this.articleList.push(...this.articles);
          this.totalImages = this.articleList?.length;
        }
        this.searchOnGoing = false;
        this.isfetchingData = false;
        if (this.articleFilter.searchText && this.isMobileView) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      (err) => {
        this.searchOnGoing = false;
        this.isfetchingData = false;
        this.loading = false;
      }
    );
  }

  articlePreview(articleId: number) {
    this.loaderService.setLoading(true);
    this.articleService.getArticleByIdForPreview(articleId, this.language).subscribe(
      (response: Article) => {
        this.selectedArticle = response;
        this.openViewArticleModal(this.viewArticleModel, articleId);
        this.loaderService.setLoading(false);
      },
      (err) => {
        this.loaderService.setLoading(false);
      }
    );
  }

  onScrollDown() {
    if (this.totalPage) {
      this.currentPage += 1;
      if (this.currentPage <= Math.ceil(this.totalPage)) {
        this.loadData();
      }
    }
  }

  // Modal Code
  private modalService = inject(NgbModal);
  openViewArticleModal(viewArticleModal: TemplateRef<any>, articleId: number) {
    this.selectedArticlId = articleId;
    this.modalService.open(viewArticleModal, {
      windowClass: 'project-modal view-article-modal',
      centered: true,
      backdropClass: 'primary-backdrop',
      size: 'xl',
      scrollable: true,
    });
  }

  stopEnter(e: any) {
    if (e.code?.toLowerCase() == 'Enter'.toLowerCase()) {
      e.preventDefault();
    }
  }

  sortItems(items: any[]): any[] {
    return items.slice().sort((item1, item2) => {
      if (item1.title.toLowerCase() < item2.title.toLowerCase()) {
        return -1;
      }
      if (item1.title.toLowerCase() > item2.title.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  showFilterTab(filterTab: ArticleFilterTabType, isShow = false) {
    this.active = 'articles';
    switch (filterTab) {
      case this.articleFilterTabType.DetailsTab:
        this.articleFilterOption.showfilterDetails =
          isShow || !this.articleFilterOption.showfilterDetails;
        this.articleFilterOption.showCategoryFilter = false;
        this.articleFilterOption.showCreatedByFilter = false;
        this.articleFilterOption.showDateFilter = false;
        break;
      case this.articleFilterTabType.DateFilterTab:
        this.articleFilterOption.showDateFilter =
          isShow || !this.articleFilterOption.showDateFilter;
        this.articleFilterOption.showCategoryFilter = false;
        this.articleFilterOption.showCreatedByFilter = false;
        this.articleFilterOption.showfilterDetails =
          !this.articleFilterOption.showDateFilter;
        break;
      case this.articleFilterTabType.CategoryTab:
        this.articleFilterOption.showCategoryFilter =
          isShow || !this.articleFilterOption.showCategoryFilter;
        this.articleFilterOption.showDateFilter = false;
        this.articleFilterOption.showCreatedByFilter = false;
        this.articleFilterOption.showfilterDetails =
          !this.articleFilterOption.showCategoryFilter;
        break;
      case this.articleFilterTabType.CreatedByTab:
        this.articleFilterOption.showCreatedByFilter =
          isShow || !this.articleFilterOption.showCreatedByFilter;
        this.articleFilterOption.showDateFilter = false;
        this.articleFilterOption.showCategoryFilter = false;
        this.articleFilterOption.showfilterDetails =
          !this.articleFilterOption.showCreatedByFilter;
        break;
      default:
        return;
    }
  }

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${jsDate.getDate()} ${month}, ${year}`;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.articleFilterOption.showDateFilter = false;
      this.articleFilterOption.showfilterDetails = true;
    } else if (this.fromDate && !this.toDate && date.equals(this.fromDate)) {
      this.toDate = date;
      this.articleFilterOption.showDateFilter = false;
      this.articleFilterOption.showfilterDetails = true;
    } else {
      this.toDate = null;
      this.fromDate = null;
    }

    if (this.toDateControl.value != this.toDate) {
      this.toDateControl.setValue(this.toDate);
      this.fromDateControl.setValue(this.fromDate);
      this.addToChip(date, date, true, ArticleFilterTabType.DateFilterTab);
      this.filterChanged.next(this.toDate);
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  onListingFilterChange($event) {
    this.listingFilterChanged.next($event);
  }

  clearDate() {
    if (this.toDate || this.fromDate) {
      this.toDate = null;
      this.fromDate = null;
      this.toDateControl.setValue(this.toDate);
      this.fromDateControl.setValue(this.fromDate);
      this.addToChip(
        this.toDateControl,
        this.toDateControl,
        true,
        ArticleFilterTabType.DateFilterTab
      );
      this.filterChanged.next(this.toDate);
    }
  }

  clearCreatedBy($event) {
    if (this.uploadedBy) {
      this.uploadedBy = null;
      this.displayselectedPeople = [];
      this.articleFilter.uploadedByUserId = [];
      this.displayFilterChips = this.displayFilterChips.filter(
        (x) =>
          (x.isArticle && x.type != ArticleFilterTabType.CreatedByTab) ||
          !x.isArticle
      );

      this.filterChanged.next($event);
    }
  }

  clearCategory($event) {
    if (this.typeSelect?.length) {
      this.typeSelect = [];
      this.displaySelectedType = [];
      this.articleFilter.category = [];
      this.displayFilterChips = this.displayFilterChips.filter(
        (x) =>
          (x.isArticle && x.type != ArticleFilterTabType.CategoryTab) ||
          !x.isArticle
      );
      this.filterChanged.next($event);
    }
  }

  addToChip(
    event: any,
    chip: any,
    isArticle: boolean,
    type: ArticleFilterTabType
  ) {
    if (isArticle && type === ArticleFilterTabType.CategoryTab) {
      if (event) {
        this.displayFilterChips.push({
          id: this.displayFilterChips?.length,
          name: chip.name,
          isArticle: isArticle,
          type: type,
        });
      } else {
        this.displayFilterChips = this.displayFilterChips.filter(
          (x) => x.name != chip.name
        );
      }
    } else if (isArticle && type === ArticleFilterTabType.CreatedByTab) {
      this.displayFilterChips = this.displayFilterChips.filter(
        (x) => x.type != type
      );
      this.displayFilterChips.push({
        id: this.displayFilterChips?.length,
        name: this.peoples.find((x) => x.id == chip).name,
        isArticle: isArticle,
        type: type,
      });
    } else if (isArticle && type === ArticleFilterTabType.DateFilterTab) {
      this.displayFilterChips = this.displayFilterChips.filter(
        (x) => x.type != type
      );
      if (this.toDateControl.value && this.fromDateControl.value) {
        this.displayFilterChips.push({
          id: this.displayFilterChips?.length,
          name: `${this.getFormattedDate(this.fromDateControl.value)}${this.toDateControl.value == this.fromDateControl.value
            ? ''
            : ' - ' + this.getFormattedDate(this.toDateControl.value)
            } `,
          isArticle: isArticle,
          type: type,
        });
      }
    } else if (!isArticle) {
      if (event) {
        this.displayFilterChips.push({
          id: this.displayFilterChips?.length,
          name: chip.title,
          isArticle: isArticle,
          type: type,
        });
      } else {
        this.displayFilterChips = this.displayFilterChips.filter(
          (x) => x.name != chip.title
        );
      }
    }
  }

  removeChips(removeChip: chips) {
    this.displayFilterChips = this.displayFilterChips.filter(
      (x) => x.id !== removeChip.id
    );
    if (
      removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.DateFilterTab
    ) {
      this.clearDate();
    } else if (
      removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.CategoryTab
    ) {
      let removeCategoryIndex = this.types.findIndex(
        (x) => x.name == removeChip.name
      );
      this.typeSelect[removeCategoryIndex] = false;
      this.onFilterChange(this.typeSelect);
    } else if (
      removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.CreatedByTab
    ) {
      this.uploadedBy = null;
      this.onFilterChange(this.uploadedBy);
    } else if (
      !removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.CategoryTab
    ) {
      let removeCategoryIndex = this.categories.findIndex(
        (x) => x.title == removeChip.name
      );
      this.selectedCategories[removeCategoryIndex] = false;
      this.filterChanged.next(this.selectedCategories);
    } else if (
      !removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.TypeOfMealTab
    ) {
      let removeTypeOfMealIndex = this.typeOfMeals.findIndex(
        (x) => x.title == removeChip.name
      );
      this.selectedTypeOfMeals[removeTypeOfMealIndex] = false;
      this.filterChanged.next(this.selectedTypeOfMeals);
    } else if (
      !removeChip.isArticle &&
      removeChip.type === ArticleFilterTabType.PriceRangeTab
    ) {
      let removePriceRangeIndex = this.priceRanges.findIndex(
        (x) => x.title == removeChip.name
      );
      this.selectedPrices[removePriceRangeIndex] = false;
      this.filterChanged.next(this.selectedPrices);
    }
  }

  // The x clears the query and its results. It deliberately leaves the search bar open: the
  // user is still searching and expects to type again, not to be dropped out of search.
  clearSearchBar() {
    // Drop the in-flight search for the text being cleared: the listing-search timer would
    // otherwise fire afterwards and navigate away with the old term, and the article debounce
    // would re-apply it.
    clearTimeout(this.debounceTimer);
    this.filter.search = '';
    this.searchChanged.next('');
    this.searchText = '';
    this.applyFilter();
    // Load-bearing: clicking the x blurs the input, and onBlur() closes the bar a tick later
    // unless focus is back inside it. This also keeps the keyboard up so typing can continue.
    this.dashboardSearchBar?.nativeElement?.focus();
  }

  private openArticle = (encodedArticleId: string) => {
    const encodedId = decodeURIComponent(encodedArticleId);
    const articleId = +atob(encodedId);
    this.isRedirectedForArticleApproval = true;
    this.articlePreview(articleId);
  };

  /* Section pinning is handled by CSS `position: sticky` (dashboard.component.scss). */

  firstSection: HTMLElement | null = null;
  secondSection: HTMLElement | null = null;

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    //const scrollY = window.scrollY;

    // if (this.firstSection) {
    //   this.firstSection.style.transform = `translateY(-${scrollY * 0.2}px)`;
    //   this.secondSection.style.marginBottom = `-${scrollY * 0.4}px`;
    // }

    // if (this.secondSection) {
    //   this.secondSection.style.transform = `translateY(-${scrollY * 0.4}px)`;
    //   this.secondSection.style.marginBottom = `-${scrollY * 0.4}px`;
    // }
  }

  onBlur() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      const isInsideContainer = this.dashboardSearchBar?.nativeElement.contains(activeElement);
      if (!isInsideContainer) {
        this.isSearchBarActive = false;
        this.cdr.detectChanges();
      }
    }, 100);
  }

  preventScrollClose(event: Event) {
    event.stopPropagation();
  }

  onDropdownShown() {
    this.setDropdownHeight();
  }

  setDropdownHeight(retries = 10) {
    const dropdown1 = this.filterDropdownMenu?.nativeElement;
    const scrollContainer = this.scrollBarContainerRef?.nativeElement;
    if (!dropdown1 || !scrollContainer || retries === 0) return;
    const element = document.getElementById('dropdown-filter');
    element.removeAttribute('ngbdropdowntoggle');
    const spaceFromTop = dropdown1.getBoundingClientRect();
    if (spaceFromTop.top > 0) {
      const windowHeight = window.innerHeight;
      const maxHeight = windowHeight - spaceFromTop.top - 30;
      scrollContainer.style.maxHeight = `${maxHeight}px`;

      scrollContainer.addEventListener('scroll', () => this.onScroll(scrollContainer), { passive: true });
    }
    else {
      setTimeout(() => this.setDropdownHeight(retries - 1), 50);
    }
  }

  onScroll(el: HTMLElement) {
    this.renderer.addClass(el, 'scrolling');
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.renderer.removeClass(el, 'scrolling');
    }, 1000);
  }
}
